module.exports = __webpack_public_path__ + "images/checklists/pointing-hand.279461d5b02296633974.svg";